module.exports = __webpack_public_path__ + "static/imagem_4-2dc46fdee9f5a7e38c23f32070f79408.jpeg";